import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex justify-content-center w-100 mt-3" }

import clientService from '@/api/Client';
import BaseInput from '@/components/base/BaseInput.vue';
import SelectVue from '@/components/SelectVue.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import {requiredRule} from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {IFormRules, ISubClientForm} from "@/interfaces/Client/ISubClient";
import SaveButton from "@/components/button/SaveButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
  subClientId: {
    type: [String, Number, null],
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ['update:modelValue', 'update:submitForm'],
  setup(__props, { emit: __emit }) {

const {t} = useI18n();
const isLoaded = ref(false);
const isSubmitting = ref(false);
const emit = __emit;

const props = __props;

const formData = ref<ISubClientForm>({
  name: '',
  parentId: '',
});

const formRules = ref<IFormRules>({
  name: requiredRule(t),
  parentId: requiredRule(t),
})

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {

    props.subClientId ?
        await clientService.putSubClient(formData.value, +props.subClientId) :
        await clientService.postSubClient(formData.value)

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));

  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getSubClientData(id: number | string) {
  try {
    const {data} = await clientService.getSubClient(+id);
    const parentClientId = data.data.parent.id;

    formData.value = {
      ...data.data,
      parentId: parentClientId,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.subClientId) {
    await getSubClientData(props.subClientId);
  }

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        novalidate: "",
        "client-dropdown": "",
        "sub-client-id": "",
        "submit-form": ""
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(BaseInput, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
              required: true,
              label: "Name",
              validation: _unref(v$).name,
              messages: _unref(v$).name.required.$message
            }, null, 8, ["modelValue", "validation", "messages"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(SelectVue, {
              modelValue: formData.value.parentId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.parentId) = $event)),
              options: __props.clientDropdown,
              "is-clear": true,
              placeholder: _ctx.$t('placeholder.client_name'),
              validation: _unref(v$).parentId,
              messages: _unref(v$).parentId.required.$message
            }, null, 8, ["modelValue", "options", "placeholder", "validation", "messages"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SaveButton, {
            label: _ctx.$t('general.button.save'),
            loading: isSubmitting.value
          }, null, 8, ["label", "loading"])
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})